import { render, staticRenderFns } from "./PayrollRequest.vue?vue&type=template&id=05970948&scoped=true"
import script from "./PayrollRequest.vue?vue&type=script&lang=js"
export * from "./PayrollRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05970948",
  null
  
)

export default component.exports